module.exports = __webpack_public_path__ + "static/media/dollar-wallet-money-svgrepo-com.9184bf85.svg";